import PropTypes from 'prop-types';

import { LoyaltyPointPropTypes } from './LoyaltyPoint/LoyaltyPoint.proptypes';
import { PricePropTypes } from './Price/Price.proptypes';
import { StocksPropTypes } from './Stocks/Stocks.proptypes';
// TODO: to finish

export const PricesAndStocksDefaultProps = {};

export const PricesAndStocksPropTypes = {
  ...StocksPropTypes,
  ...PricePropTypes,
  ...LoyaltyPointPropTypes,
  available_quantity: PropTypes.number,
  delay_quantity: PropTypes.number,
  has_price: PropTypes.bool,
  has_stock: PropTypes.bool,
  sku: PropTypes.string,
  stock_status: PropTypes.string,
  sale_unit: PropTypes.string, // TODO: in Price > to remove here
  invoice_unit: PropTypes.string, // TODO: in Price > to remove here
  sales_packaging: PropTypes.number, // TODO: in Price > to remove here
  split_packaging: PropTypes.bool, // TODO: in Price > to remove here
  product: PropTypes.shape({}), // TODO: to remove useless
};
